export const hideFingerIcon = {
  type: 'HIDE_FINGER_ICON'
}
